import { render, staticRenderFns } from "./DetailInvoiceKirimBalik.vue?vue&type=template&id=7205649a&"
import script from "./DetailInvoiceKirimBalik.vue?vue&type=script&lang=js&"
export * from "./DetailInvoiceKirimBalik.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports